function getSvgs(r) {
  r.keys().forEach(r);
}
getSvgs(require.context("../svg/", true, /\.svg$/));
